module.exports = __webpack_public_path__ + "static/media/es.bf1264bd.pdf";